export default __webpack_public_path__ + "static/media/logo.84cac2c6.png";